module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_8017.4a6a27fb.png";